module.exports = __webpack_public_path__ + "img/AZ.785b6d4a.svg";